import { TextField, TextFieldVariants } from "@mui/material";
import { ChangeEventHandler, memo } from "react";
import * as styledTextField from "./styled-text-field.module.css";

export type StyledTextFieldProps = {
  label?: string;
  variant?: TextFieldVariants | undefined;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  fullWidth?: boolean;
  value: string;
  InputProps?: any;
  padding?: string;
  fontFamily?: string;
};

export const StyledTextField = memo(
  ({
    label,
    variant = "outlined",
    onChange,
    fullWidth,
    value,
    InputProps,
    padding,
    fontFamily,
  }: StyledTextFieldProps) => {
    return (
      <div className={styledTextField.textField}>
        <TextField
          value={value}
          label={label}
          variant={variant}
          onChange={onChange}
          fullWidth={fullWidth}
          inputProps={{
            style: {
              fontFamily: fontFamily || "Axiforma, sans-serif",
              fontSize: "14px",
              padding,
            },
          }}
          InputLabelProps={{
            style: {
              fontFamily: fontFamily || "Axiforma, sans-serif",
              fontSize: "14px",
            },
          }}
          InputProps={InputProps}
        />
      </div>
    );
  },
);
